/**
 * Build the OAuth `state` param: the client type plus optional pipe-separated
 * suffixes — `ref:CODE` (stashed invite code) and `src:guest_tour` (guest-tour
 * conversion). localStorage can't reach the backend OAuth callback, but state is
 * echoed back by Google verbatim, so it's the one channel that survives the
 * round-trip. The backend (AuthController::parseOAuthState) format-validates /
 * allowlists every suffix and applies them ONLY when the sign-in creates a NEW
 * account.
 *
 * Shared by the login and register pages so the grammar can't drift between them.
 */
export function buildOAuthState(
  clientType: 'mobile_app' | 'web_browser',
  referralCode: string | null,
  isGuest: boolean,
  stashedSource: string | null = null,
  stashedVariant: string | null = null,
): string {
  let state: string = clientType;
  if (referralCode) state += `|ref:${referralCode}`;
  // guest_tour outranks a stashed URL source (utils/signup-source.ts): the
  // tour is the in-product journey that actually converted them — same
  // precedence as the email register path, so the two cannot disagree.
  if (isGuest) state += '|src:guest_tour';
  else if (stashedSource) state += `|src:${stashedSource}`;
  // The website A/B variant rides the OAuth round-trip too, or a Google
  // sign-up from a variant link is never attributed (class D, 2026-08-27).
  if (stashedVariant) state += `|v:${stashedVariant}`;

  return state;
}
